import React, { useEffect, useState } from 'react';
import logoSvg from 'assets/images/logo.svg';
import styles from './BundleCard.module.css';
import { MdCheck, MdClose, MdInfo } from 'react-icons/md';
import SubscriptionDialog from '../SubscriptionDialog/SubscriptionDialog';
import { Tooltip } from '@mui/material';
import YearlyMonthlyDialog from '../YearlyMonthlyDialog/YearlyMonthlyDialog';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const BundleCard = ({ bundleData, currentTier, assign, unassign, isAnnual, user, cardRegisterData }) => {
  const [open, setOpen] = useState();
  const [yearlyOpen, setYearlyOpen] = useState();
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const { t } = useTranslation();

  const IsCurrentOrNext = ({ isHeader }) => {
    const isCurrent = currentTier?.id === bundleData?.id;
    const isNext =
      user?.ownedShops[0]?.shopTier.id !==
        user?.ownedShops[0]?.historyList[user.ownedShops[0].historyList.length - 1]?.tier?.id &&
      bundleData?.id === user?.ownedShops[0]?.historyList[user.ownedShops[0].historyList.length - 1]?.tier?.id;

    if (isHeader) {
      if (isCurrent) {
        return <div className={styles.current_banner}>{t('subscription.bundles.current')}</div>;
      }
      if (isNext) {
        return (
          <div className={styles.next_banner}>
            {t('subscription.bundles.nextSubscription')} (
            {user?.ownedShops[0]?.historyList[user.ownedShops[0].historyList.length - 1]?.yearlyPricing
              ? t('subscription.bundles.yearly')
              : t('subscription.bundles.monthly')}
            )
          </div>
        );
      }
    } else {
      if (isCurrent) {
        return `${styles.mainContainerOutlined} ${styles.fadeIn}`;
      }
      if (isNext) {
        return `${styles.mainContainerOutlinedNext} ${styles.fadeIn}`;
      } else {
        return styles.mainContainer;
      }
    }
  };

  return (
    <div className={styles.outsideCard}>
      <div className={IsCurrentOrNext({ isHeader: false })}>
        {IsCurrentOrNext({ isHeader: true })}
        <div className={styles.innerPart}>
          <div className={styles.logoContainer}>
            <img src={logoSvg} alt='logo' />
            {user?.ownedShops[0]?.historyList?.length > 0 &&
              user?.ownedShops[0]?.shopTier.id !==
                user?.ownedShops[0]?.historyList[user.ownedShops[0].historyList.length - 1]?.tier?.id &&
              currentTier?.id === bundleData?.id && (
                <div className={styles.counter}>
                  {Math.max(
                    0,
                    Math.ceil(
                      (new Date(
                        user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData.length - 1]?.dueDate
                      ) -
                        new Date()) /
                        (1000 * 60 * 60 * 24)
                    )
                  )}{' '}
                  {t('subscription.bundles.daysLeft')}
                </div>
              )}
          </div>
          <h2>{t(`subscription.bundles.${bundleData?.name}`)}</h2>
          <div className={styles.infoSection}>
            <div className={styles.info_item}>
              {t('subscription.galleryCreation')}: <MdCheck color='green' size={20} />
            </div>
            <div className={styles.info_item}>
              {t('subscription.photoUpload')}: <MdCheck color='green' size={20} />
            </div>
            <div className={styles.info_item}>
              {t('subscription.ownProductDefinition')}: <MdCheck color='green' size={20} />
            </div>
            <div className={styles.info_item}>
              {t('subscription.orderDeadline')}:{' '}
              {bundleData?.galleryExpiryDate ? <MdCheck color='green' size={20} /> : <MdClose color='red' size={20} />}
            </div>
            <div className={styles.info_item}>
              {t('subscription.onlinePayment')}:{' '}
              {bundleData?.onlinePayment ? <MdCheck color='green' size={20} /> : <MdClose color='red' size={20} />}
            </div>
            <div className={styles.info_item}>
              {t('subscription.pricingTemplate')}:{' '}
              {bundleData?.pricingTemplates ? <MdCheck color='green' size={20} /> : <MdClose color='red' size={20} />}
            </div>
            <div className={styles.info_item}>
              {t('subscription.automaticInvoice')}:{' '}
              {bundleData?.automaticInvoice ? <MdCheck color='green' size={20} /> : <MdClose color='red' size={20} />}
            </div>
            <div className={styles.info_item}>
              {t('subscription.galleryLimit')}: <span>{`${bundleData?.galleryLimit} db`}</span>
            </div>
            <div className={styles.info_item}>
              {t('subscription.productLimit')}: <span>{`${bundleData?.productsLimit} db`}</span>
            </div>
          </div>
          {bundleData.recurringPrice > 0 ? (
            isAnnual ? (
              <div className={styles.payment}>
                {bundleData.recurringPriceYearly} {t('common.currency.perYear')}
              </div>
            ) : (
              <div className={styles.payment}>
                {bundleData.recurringPrice} {t('common.currency.perMonth')}
              </div>
            )
          ) : bundleData.commissionRate > 0 ? (
            <Tooltip
              title={`${t('subscription.bundles.professional1')} ${bundleData.commissionRate * 100}% ${t(
                'subscription.bundles.professional2'
              )}`}>
              <div className={styles.payment}>
                {t('subscription.commissionRate')} {bundleData.commissionRate * 100} % <MdInfo size={20} />
              </div>
            </Tooltip>
          ) : isAnnual ? (
            <div className={styles.payment}>0 {t('common.currency.perYear')}</div>
          ) : (
            <div className={styles.payment}>0 {t('common.currency.perMonth')}</div>
          )}
          <button
            className={styles.introButton}
            style={{
              backgroundColor:
                bundleData?.commissionRate === 0 &&
                bundleData?.recurringPrice > 0 &&
                user?.ownedShops[0]?.historyList?.length > 0 &&
                bundleData?.id === shopTier?.id &&
                (user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.tier?.id ===
                shopTier?.id
                  ? user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
                  : user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 2]?.yearlyPricing) !==
                  isAnnual
                  ? 'var(--primary-background-primary)'
                  : 'var(--primary-background-secondary)',
              color:
                bundleData?.commissionRate === 0 &&
                bundleData?.recurringPrice > 0 &&
                user?.ownedShops[0]?.historyList?.length > 0 &&
                bundleData?.id === shopTier?.id &&
                (user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.tier?.id ===
                shopTier?.id
                  ? user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
                  : user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 2]?.yearlyPricing) !==
                  isAnnual
                  ? 'white'
                  : 'black'
            }}
            onClick={
              bundleData?.commissionRate === 0 &&
              bundleData?.recurringPrice > 0 &&
              user?.ownedShops[0]?.historyList?.length > 0 &&
              bundleData?.id === shopTier?.id &&
              (user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.tier?.id === shopTier?.id
                ? user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
                : user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 2]?.yearlyPricing) !==
                isAnnual
                ? () => setYearlyOpen(true)
                : () => setOpen(true)
            }>
            {bundleData?.commissionRate === 0 &&
            bundleData?.recurringPrice > 0 &&
            user?.ownedShops[0]?.historyList?.length > 0 &&
            bundleData?.id === shopTier?.id &&
            (user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.tier?.id === shopTier?.id
              ? user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
              : user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 2]?.yearlyPricing) !==
              isAnnual
              ? isAnnual
                ? t('subscription.bundles.switchToYearly')
                : t('subscription.bundles.switchToMonthly')
              : t('subscription.bundles.selectSubscription')}
          </button>
        </div>
      </div>
      <SubscriptionDialog
        open={open}
        setOpen={setOpen}
        bundleData={bundleData}
        assign={assign}
        unassign={unassign}
        isAnnual={isAnnual}
      />
      <YearlyMonthlyDialog
        user={user}
        isAnnual={isAnnual}
        data={cardRegisterData}
        open={yearlyOpen}
        setOpen={setYearlyOpen}
        assignTier={assign}
      />
    </div>
  );
};

export default BundleCard;
